import React from 'react'
import BaseComponent from './BaseComponent'
import { NavLink } from 'react-router-dom'
import Footer from './Footer'
import SideNav from './SideNav'
import _ from 'lodash'

export default class RealizationsPage extends BaseComponent {

  constructor(props) {
    super(props)
    this.state = { category: this.props.data.categories[0].id, tags: [], tag: 0 }
    this._bind('setCategory', 'setTags', 'toggleTag')
  }

  setCategory(id) {
    this.setState({ category: id })
  }

  setTags(id) {
    this.setState({ tag: id })
  }

  toggleTag(i) {
    let obj = this.state.tags

      if (this.state.tags.indexOf(i) !== -1) {
        let index = this.state.tags.indexOf(i)
        obj.splice(index, 1)
      } else {
        obj.push(i)
      }

      this.setState({ tags: obj })
  }

  render() {
    const galleryPage = _.filter(this.props.data.pages, { template: "gallery" })[0]

    let categories = this.props.data.categories.map((item, i) => {
      return (
        <li key={ i } className={ this.state.category === item.id ? "active" : "" } onClick={ this.setCategory.bind(null, item.id) }>{ item.title }</li>
      )
    })

    let tags = this.props.data.tags.map((item, i) => {
      return (
        <li key={ i } className={ this.state.tags.indexOf(item.name) !== -1 ? "active" : "" } onClick={ this.toggleTag.bind(null, item.name) }>{ item.name }</li>
      )
    })

    let selectedRealizations = _.filter(this.props.data.gallery_new, { category: this.state.category })

    if (this.state.tags.length > 0) {
      selectedRealizations = _.filter(selectedRealizations, (item) => {
        for (var i = 0; i < this.state.tags.length; i++) {
          for (var j = 0; j < item.tags.length; j++) {
            if (item.tags[j].name === this.state.tags[i]) {
              return item
            }
          }
        }
      })
    }

    let gallery = selectedRealizations.map((item, i) => {
      return (
        <li key={ i } style={{ backgroundImage: "url(" + item.image + ")" }}><NavLink to={ "/galeria/album/" + item.slug }><div className="cover"><h4>{ item.title }</h4></div></NavLink></li>
      )
    })

    return (
      <section className="realizations">
      	<ul className="breadcrumbs">
      		<div className="container-big">
	      		<li><NavLink to="/">Strona główna</NavLink></li>
	      		<li><NavLink to="/galeria">Galeria</NavLink></li>
      		</div>
      		<div className="bottom"></div>
      	</ul>
        <div className="outer-container">
          <SideNav data={ this.props.data }/>
        	<div className="container">
        		<h1 dangerouslySetInnerHTML={{ __html: this.addColor(galleryPage.additional_fields.pageTitle) }}></h1>
            <p dangerouslySetInnerHTML={{ __html: galleryPage.additional_fields.content }}></p>
        	  <ul className="categories-list">
               { categories }
            </ul>
            <div><p className="filters">Filtruj według:</p></div>
            <ul className="tags-list">
              { tags }
            </ul>
            <ul className="realizations-list">
              { gallery }
            </ul>
            { gallery.length < 1 ? <p>Brak wyników!</p> : null}
          </div>
        </div>
      	<Footer data={ this.props.data } settings={ this.props.data.settings }/>
      </section>
    )
  }
}


// WEBPACK FOOTER //
// ./src/app/components/GalleryNewPage.js